<template>
    <div class="container spinner" v-if="loading === true">
        <q-spinner-clock class="spinner-icon" color="primary" />
        <q-tooltip :offset="[0, 8]">Loading</q-tooltip>
    </div>
    <Card :sessions="sessions" />
</template>

<script setup>
import { useRoute, useRouter } from "vue-router"
import Card from "../components/Card.vue"
import SessionCardSkeleton from "../components/SessionCardSkeleton.vue"
import { onMounted, ref, watch, watchEffect } from "vue"     
import axios from "axios"

    const props = defineProps(['searchFilter', 'loading', 'search'])
    const emits = defineEmits(['apiSwap'])
    const loading = ref(false)

    const route = useRoute()
    const router = useRouter()

    ///DATABASE RESULT
    const sessions = ref([])
    const sessionFacilitators = ref([])

    const queryString = route.fullPath.split('/programme')[1]

    console.log(queryString)
  
    const getSessions = async () =>  {
        try {
            loading.value = true
            // const response = await axios.get(`http://127.0.0.1:8000/api/session${queryString}`)
            const response = await axios.get(`https://www.utaresources.mmu.ac.uk/leed-conference-23/server/public/api/session${queryString}`)
            sessions.value = response.data
            sessionFacilitators.value = response.data.facilitators
            emits('apiSwap')
            loading.value = false
        } catch (error) {
            loading.value = false
        }

        loading.value = false
    }
    
    getSessions()

</script>

